"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var typeChecks_1 = require("../utils/typeChecks");
var ArticleQuery = /** @class */ (function (_super) {
    __extends(ArticleQuery, _super);
    function ArticleQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArticleQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
    };
    ArticleQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, code = _a.code, codeQuery = _a.codeQuery, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ code: code,
            codeQuery: codeQuery }, (options.portfolio || {}));
    };
    ArticleQuery.prototype.getRawValue = function (executionOptions) {
        var code = this.options.code;
        var instance = this.getPortfolioFromContext(executionOptions);
        if (typeChecks_1.isObject(instance) && code) {
            return instance[code];
        }
        return undefined;
    };
    return ArticleQuery;
}(BaseQuery_1.BaseQuery));
exports.ArticleQuery = ArticleQuery;
//# sourceMappingURL=ArticleQuery.js.map